import React from 'react'
import { Link } from 'react-router-dom'

export function ImpressumContent({ showHeading = true } = {}) {
  return (
    <div className="max-w-2xl w-full bg-white shadow rounded-lg p-6 space-y-4">
      {showHeading && <h1 className="text-2xl font-semibold">Impressum</h1>}
      <div className="text-sm text-gray-700 space-y-1">
        <p>FlexWise UG (haftungsbeschränkt)</p>
        <p>Septimerstraße 18</p>
        <p>13407 Berlin</p>
        <p>Geschäftsführung: Jelka Likus</p>
        <p>E-Mail: <a className="text-blue-600 underline" href="mailto:fragen@flexwise.info">fragen@flexwise.info</a></p>
        <p>Eingetragen im Handelsregister beim Amtsgericht Berlin-Charlottenburg</p>
        <p>Handelsregisternummer: HRB 276963 B</p>
        <p>Umsatzsteuer-ID: DE456865358</p>
      </div>
      <div className="pt-2 hidden sm:block">
        <Link to="/" className="text-blue-600 hover:underline">Zurück</Link>
      </div>
    </div>
  )
}

export default function Impressum() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <ImpressumContent />
    </div>
  )
}
